import { Skin, SKIN, THEME_OPTION, ThemeOption } from '../types/enums';

export const DEFAULT_THEME = THEME_OPTION.GREEN;
export const DEFAULT_SKIN = SKIN.BET365;

export const DEFAULT_SKIN_THEME: Record<Skin, ThemeOption> = {
  [SKIN.BET365]: THEME_OPTION.GREEN,
  [SKIN.GOLA]: THEME_OPTION.GREEN,
  [SKIN.NEOBET]: THEME_OPTION.NEOBET,
};
